export class BannerEndpoint {
  // Landing page
  getListBanner(): string {
    return `horde/v1/banner`;
  }
}
